import { render } from "./HighlightsDetail.vue?vue&type=template&id=6980cea0&scoped=true"
import script from "./HighlightsDetail.vue?vue&type=script&lang=js"
export * from "./HighlightsDetail.vue?vue&type=script&lang=js"

import "./HighlightsDetail.vue?vue&type=style&index=0&id=6980cea0&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6980cea0"]])

export default __exports__